import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import { FaviconManager } from "@/components/Logo";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import PortalLayout from "@/pages/portal/PortalLayout";
import PortalHome from "@/pages/portal/Home";
import Renungan from "@/pages/portal/Renungan";
import Grow from "@/pages/portal/Grow";
import PortalEvents from "@/pages/portal/Events";
import Profile from "@/pages/portal/Profile";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Members from "@/pages/admin/Members";
import Offerings from "@/pages/admin/Offerings";
import Checkin from "@/pages/admin/Checkin";
import ResourceManager from "@/pages/admin/ResourceManager";
import Pastoral from "@/pages/admin/Pastoral";
import Settings from "@/pages/admin/Settings";
import Reports from "@/pages/admin/Reports";
import Birthdays from "@/pages/admin/Birthdays";
import SiteContent from "@/pages/admin/SiteContent";
import Doa from "@/pages/portal/Doa";
import Persembahan from "@/pages/portal/Persembahan";
import Giving from "@/pages/Giving";
import Kehadiran from "@/pages/portal/Kehadiran";
import MyMinistry from "@/pages/portal/MyMinistry";
import ServeUp from "@/pages/portal/ServeUp";
import UsherScan from "@/pages/portal/UsherScan";
import CommunityLeader from "@/pages/portal/CommunityLeader";
import CommunityReport from "@/pages/admin/CommunityReport";
import Ministry from "@/pages/admin/Ministry";
import WhatsAppGateway from "@/pages/admin/WhatsApp";
import ELearning from "@/pages/portal/ELearning";
import CourseView from "@/pages/portal/CourseView";
import ELearningAdmin from "@/pages/admin/ELearning";
import VerifyCertificate from "@/pages/VerifyCertificate";
import InviteAccept from "@/pages/InviteAccept";
import Invitations from "@/pages/admin/Invitations";
import WelcomeScreen from "@/pages/WelcomeScreen";
import VerifyEmail from "@/pages/VerifyEmail";
import PrayerRequest from "@/pages/PrayerRequest";
import WelcomeAdmin from "@/pages/admin/WelcomeAdmin";
import PushSettings from "@/pages/admin/PushSettings";
import LeaderboardAdmin from "@/pages/admin/LeaderboardAdmin";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously, before any protected route runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/verify/*" element={<VerifyCertificate />} />
      <Route path="/welcome" element={<WelcomeScreen />} />
      <Route path="/pray" element={<PrayerRequest />} />
      <Route path="/persembahan" element={<Giving />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/portal" element={<Protected><PortalLayout /></Protected>}>
        <Route index element={<PortalHome />} />
        <Route path="renungan" element={<Renungan />} />
        <Route path="grow" element={<Grow />} />
        <Route path="events" element={<PortalEvents />} />
        <Route path="profile" element={<Profile />} />
        <Route path="doa" element={<Doa />} />
        <Route path="persembahan" element={<Persembahan />} />
        <Route path="kehadiran" element={<Kehadiran />} />
        <Route path="ministry" element={<MyMinistry />} />
        <Route path="serve-up" element={<ServeUp />} />
        <Route path="usher-scan" element={<UsherScan />} />
        <Route path="community" element={<CommunityLeader />} />
        <Route path="elearning" element={<ELearning />} />
        <Route path="elearning/:courseId" element={<CourseView />} />
      </Route>
      <Route path="/admin" element={<Protected admin><AdminLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="members" element={<Members />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="offerings" element={<Offerings />} />
        <Route path="checkin" element={<Checkin />} />
        <Route path="content/:resource" element={<ResourceManager />} />
        <Route path="pastoral" element={<Pastoral />} />
        <Route path="whatsapp" element={<WhatsAppGateway />} />
        <Route path="settings" element={<Settings />} />
        <Route path="reports" element={<Reports />} />
        <Route path="birthdays" element={<Birthdays />} />
        <Route path="site" element={<SiteContent />} />
        <Route path="welcome" element={<WelcomeAdmin />} />
        <Route path="push" element={<PushSettings />} />
        <Route path="ministry" element={<Ministry />} />
        <Route path="leaderboard" element={<LeaderboardAdmin />} />
        <Route path="communities/report" element={<CommunityReport />} />
        <Route path="elearning" element={<ELearningAdmin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FaviconManager />
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
